module.exports = __webpack_public_path__ + "img/crustacean.54118ef1.svg";